import { useSelector } from "react-redux";

export default function Experience() {
  // const experience = [
  //   {
  //     role: "Full Stack Developer",
  //     company: "Tech Company",
  //     period: "2023 - Present",
  //     description: "Building modern applications and APIs."
  //   },
  //   {
  //     role: "Frontend Developer",
  //     company: "Creative Agency",
  //     period: "2021 - 2023",
  //     description: "Developed responsive websites and dashboards."
  //   }
  // ];

  const { loading, error, data } = useSelector((state) => state.portfolio);
  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading data</div>;

  return (
    <section id="experience" className="py-20 bg-white dark:bg-gray-900">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-heading font-bold mb-10 text-center">
          Work Experience
        </h2>
        <div className="space-y-8">
          {data.experience.map((exp, idx) => (
            <div key={idx} className="bg-gray-100 dark:bg-gray-800 p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-primary">{exp.role}</h3>
              <p className="text-sm text-gray-500">{exp.company} - {exp.period}</p>
              <p className="mt-2 text-gray-700 dark:text-gray-300 whitespace-pre-line">{exp.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
